<template>
    <div v-if="!print " class="card p-3 bg-white mb-1">
        <div class="card-header">
            <h3>{{ index+1 }}. zsűritag</h3>
            <button class="x-icon-delete" @click.prevent="deleteZsuritag" title="Zsűritag törlése"></button>
            <button class="x-icon-up" :disabled="index == 0" @click.prevent="upZsuritag" title="Zsűritag feljebb csúsztatása"></button>
            <button class="x-icon-down" :disabled="index == jegyzokonyv.zsuritagok.length-1" @click.prevent="downZsuritag" title="Zsűritag lejjebb csúsztatása"></button>
        </div>
        <div class="card-body">
            <form>
                <div class="form-group mb-1">
                    <label for="nev">Titulus</label>
                    <input type="text" id='titulus' v-model.trim="zsuritag.titulus" class="form-control" title="Zsűritag titulusa(i) (pl. 'Prof. Dr.')">
                </div>
                <div class="form-group mb-1">
                    <label for="nev">Vezetékneve</label>
                    <input type="text" id='nev' v-model.trim="zsuritag.vezetekNev" class="form-control" title="Zsűritag vezetékneve" required>
                </div>
                <div class="form-group mb-1">
                    <label for="nev">Keresztneve</label>
                    <input type="text" id='nev' v-model.trim="zsuritag.keresztNev" class="form-control" title="Zsűritag keresztneve" required>
                </div>
                <div class="form-group mb-1">
                    <label for="email">E-mail címe</label>
                    <input type="email" id='email' v-model.trim="zsuritag.email" class="form-control" required @blur="zsuritag.email = zsuritag.email.toLowerCase()">
                </div>
                <div>
                    <label>Munkahelyek</label>
                    <munkahely v-for="(munkahely, index) in zsuritag.munkahelyek" :index="index" :munkahely="munkahely" :szemely="zsuritag" />
                    <div class="text-center">
                        <button class="btn btn-secondary btn-sm float-sm-left" @click.prevent="addFelsooktatasiMunkahely">Felsőoktatási munkahely felvétele</button>
                        &nbsp;
                        <button class="btn btn-secondary btn-sm float-sm-right" @click.prevent="addEgyebMunkahely">Egyéb munkahely felvétele</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <td v-if="print" style="vertical-align: top; text-align: center; border-top: 1px solid black;">
        {{ zsuritag.titulus }} {{ zsuritag.vezetekNev }} {{ zsuritag.keresztNev }}
        <div v-for="(munkahely, index) in zsuritag.munkahelyek" :index="index" :munkahely="munkahely" :szemely="zsuritag">
            <i>{{munkahely.intezmenyKod}} {{munkahely.karKod}} {{munkahely.munkahelyNev}} ({{ munkahely.beosztas }})</i>
        </div>
    </td>
    <td width="20px;"></td>
</template>

<script>
import Munkahely from './Munkahely.vue'

export default {
    components: {
        Munkahely
    },
    props: ['zsuritag', 'jegyzokonyv', 'index', 'print'],
    methods: {
        deleteZsuritag() {
            const index = this.jegyzokonyv.zsuritagok.indexOf(this.zsuritag);
            if (index > -1)
                this.jegyzokonyv.zsuritagok.splice(index, 1);
        },
        upZsuritag() {
            const index = this.jegyzokonyv.zsuritagok.indexOf(this.zsuritag);
            if (index > 0) {
                let tmp = this.jegyzokonyv.zsuritagok[index-1];
                this.jegyzokonyv.zsuritagok[index - 1] = this.jegyzokonyv.zsuritagok[index];
                this.jegyzokonyv.zsuritagok[index] = tmp;
            }
        },
        downZsuritag() {
            const index = this.jegyzokonyv.zsuritagok.indexOf(this.zsuritag);
            if (index < this.jegyzokonyv.zsuritagok.length) {
                let tmp = this.jegyzokonyv.zsuritagok[index+1];
                this.jegyzokonyv.zsuritagok[index + 1] = this.jegyzokonyv.zsuritagok[index];
                this.jegyzokonyv.zsuritagok[index] = tmp;
            }
        },
        availableKar() {
            var intezmenyKod = this.zsuritag.intezmenyKod;
            var intezmenyObj = this.intezmenyek.find((x) => x.kod == intezmenyKod);
            if (intezmenyObj)
                return intezmenyObj.karok;
            else
                return this.intezmenyek;
        },
        addFelsooktatasiMunkahely() {
            this.$storage.createFelsooktatasiMunkahely(this.zsuritag);
        },
        addEgyebMunkahely() {
            this.$storage.createEgyebMunkahely(this.zsuritag);
        }
    }
}
</script>
